// Chakra imports
import { Box, Flex, Icon, Progress, Text, useColorModeValue } from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card';
import IconBox from 'components/icons/IconBox';
import Menu from 'components/menu/MainMenu';
import React from 'react';
// Assets
import { MdOutlineCloudDone } from 'react-icons/md';

export default function ProfileCompletion(props: { completed: number;[x: string]: any }) {
	const { completed } = props;
	// Chakra Color Mode
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
	const brandColor = useColorModeValue('brand.500', 'white');
	const textColorSecondary = 'gray.400';
	const box = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');
	return (
		<Card mb={{ base: '0px', lg: '20px' }} alignItems='center'>
			<Flex w='100%'>
				<Menu ms='auto' />
			</Flex>

			<Text color={textColorPrimary} fontWeight='bold' fontSize='2xl' mt='10px' textAlign={`center`}>
				Datos perfil
			</Text>
			<Text color={textColorSecondary} fontSize='md' maxW={{ base: '100%', xl: '80%', '3xl': '60%' }} mx='auto' textAlign={`center`}>
				Info & porcentaje de completitud de perfil
			</Text>
			<Box w='100%' mt='auto'>
				<Flex w='100%' justify='space-between' mb='10px'>
					<Text color={textColorSecondary} fontSize='sm' maxW='40%'>
						0 %
					</Text>
					<Text color={textColorSecondary} fontSize='sm' maxW='40%'>
						100 %
					</Text>
				</Flex>
				<Progress alignItems='start' colorScheme='brandScheme' value={completed} w='100%' />
			</Box>
		</Card>
	);
}
